import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { PIE_CHART } from "../../helpers/api";

function SimplePieChart() {
    const [series, setSeries] = useState([100, 100]);

    const data = {
        series: series,

        options: {
            chart: {
                type: 'donut',
            },
            fill: {
                type: "solid",
                colors: ["#8F43EE", "#E7D4FF"]
            },
            legend: {
                show: true,
                showForSingleSeries: false,
                showForNullSeries: true,
                showForZeroSeries: true,
                position: 'bottom',
                horizontalAlign: 'center',
                floating: false,
                fontSize: '14px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 400,
                formatter: undefined,
                inverseOrder: false,
                width: undefined,
                height: undefined,
                tooltipHoverFormatter: undefined,
                customLegendItems: [],
                offsetX: 0,
                offsetY: 0,
                labels: ["Bought", "Used"],
                markers: {
                    width: 12,
                    height: 12,
                    strokeWidth: 0,
                    strokeColor: '#fff',
                    fillColors: ["#8F43EE", "#E7D4FF"],
                    radius: 12,
                    customHTML: undefined,
                    onClick: undefined,
                    offsetX: 0,
                    offsetY: 0
                },
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    };

    const piechart = async () => {
        try {
            const response = await PIE_CHART();
            const { Bought, Used } = response.message;
            setSeries([Bought, Used]);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        piechart();
    }, []);

    return (
        <>
            <ReactApexChart options={data.options} series={data.series} type="donut" />
        </>
    );
}

export default SimplePieChart;